export const internalDashboardTabsArray = [
  { label: "Key Metrics", key: "key-matrics" },
  { label: "User Activity", key: "user-activity" },
  { label: "Revenue", key: "revenue" },
  { label: "Tickets", key: "tickets" },
];
